import type { RootState } from 'reducers/types';

export const getPublicKey = (state: RootState) => {
  const { publicKey } = state;

  return publicKey;
};
